import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeProveedor } from "../../../../../../redux/actions/resolucion";
import ProvedoresTable from "./ProveedoresTable";
import ProveedoresFormContainer from "./form/ProveedoresFormContainer";



const ProveedoresTableContainer = ({ handleNextStep, handlePreviousStep, stepper }) => {
    const dispatch = useDispatch();
    const [openProveedoresForm, setOpenProveedoresForm] = useState(false);
    const [proveedor, setProveedor] = useState();
    const proveedores = useSelector((state) => state.resolucion.abmSustancia.proveedores);
    const handleGoNext = () => {
        handleNextStep("Part4");
    };

    const handleGoBack = () => {
        handlePreviousStep("Part2");
    }

    const handleOpenForm = (proveedor) => {
        setProveedor(proveedor);
        setOpenProveedoresForm(true);
    }
    const handleDelete = (data) => {
        dispatch(removeProveedor(data.map((v) => v.index)));
    }

    return (
        <>
            <ProvedoresTable
                handleGoBack={handleGoBack}
                handleGoNext={handleGoNext}
                data={proveedores}
                handleOpenForm={handleOpenForm}
                handleDelete={handleDelete}
                stepper={stepper}
            />
            <ProveedoresFormContainer
                open={openProveedoresForm}
                formValues={proveedor}
                handleClose={() => setOpenProveedoresForm(false)}

            />
        </>

    )
}

export default ProveedoresTableContainer;